import { mapGetters } from 'vuex'
import { generateMetaInfo } from '../../common'

import Search from '../../components/Search'

export default {
  name: 'SearchView',
  computed: {
    ...mapGetters(['loading', 'getPageBySlug', 'options', 'pages']),
    page () {
      return this.getPageBySlug('suchen') ? this.getPageBySlug('suchen') : this.getPageBySlug('search')
    },
    pageTitle () {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered
    }
  },
  mounted () {
    this.setCurrentPage(this.page)
  },
  watch: {
    '$route': function () {
      this.setCurrentPage(this.page)
    },
    loading: function () {
      this.setCurrentPage(this.page)
    }
  },
  methods: {
    setCurrentPage (page) {
      this.$store.dispatch('setCurrentPage', page)
    }
  },
  metaInfo () {
    const page = this.page
    return page ? generateMetaInfo(this.options, this.page) : {}
  },
  render (h) {
    const { loading, pages } = this
    return (
      !loading
      ? <div class='page'>
        <Search list={pages}/>
      </div>
      : null
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/Search/index.js